webpackJsonp([93882644997715],{

/***/ 1726:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CouponProduct","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"autoApply","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"couponId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"productId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-coupon-product-38bed1e2db26dfb43901.js